<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('publications') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_publication')"
        :loading="savingPublication"
        :saving="savingPublication"
        @click="initPublication"
      />
    </div>

    <BaseTableLoader :loading="!publications">
      <PublicationsTable
        :items="publications"
        :pagination="publicationsPagination"
        :loading="loadingPublications"
        @edit="$router.push({ name: 'editPublication', params: { id: $event.id } })"
        @update:page="onPageChange"
        @delete="deletePublication"
        @click:image="viewImage"
      />
    </BaseTableLoader>
    <router-view @click:close="closeImage" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import BaseTableLoader from '../../components/base/BaseTableLoader';
import PublicationsTable from '../../components/PublicationsTable';

export default {
  name: 'Publications',

  components: { BaseTableLoader, BasePrimaryActionButton, PublicationsTable },

  created() {
    if (!this.publications) {
      this.fetchPublications(this.$route.query);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (
      JSON.stringify(this.publicationFilterParams) !== JSON.stringify(to.query) &&
      to.name === 'publications'
    ) {
      this.fetchPublications(to.query);
    }
    next();
  },

  computed: mapState('publications', [
    'publications',
    'publicationsPagination',
    'publicationFilterParams',
    'loadingPublications',
    'savingPublication',
  ]),

  methods: {
    ...mapActions('publications', ['fetchPublications', 'storePublication', 'deletePublication']),

    initPublication() {
      this.storePublication().then((res) => {
        this.$router.push({ name: 'editPublication', params: { id: res.data.id } });
      });
    },

    onPageChange(page) {
      const query = { ...this.publicationFilterParams, page };
      this.$router.push({ name: 'publications', query });
    },

    viewImage(image) {
      this.$router.push({ name: 'publications/images', params: { url: image.image_path } });
    },

    closeImage() {
      this.$router.push({ name: 'publications' });
    },
  },
};
</script>

<style scoped></style>
